import {
    AfterContentInit,
    Component,
    ContentChildren,
    EventEmitter,
    HostListener,
    Output,
    QueryList,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { MultiTabContextMenuItemRefDirective } from '../../../../../Shared/Directives/proprietary/multi-tab-context-menu-item-ref.directive';

export interface ContextMenuPanel {
    templateRef: TemplateRef<any>;
    readonly closed: EventEmitter<void>;
}

@Component({
    standalone: false,
    selector: 'multi-tab-context-menu',
    template: `
    <ng-template>
      <div
        (click)="closed.emit()"
        style="padding:0.3125rem 0; background-color: var(--aurora-primitive-signal-600);position:absolute;width:150px;"
      >
        <ng-content></ng-content>
      </div>
    </ng-template>
  `
})
export class MultiTabContextMenuComponent implements ContextMenuPanel, AfterContentInit {
    @ViewChild(TemplateRef) templateRef: TemplateRef<any>;
    @Output() closed = new EventEmitter<void>();

    @ContentChildren(MultiTabContextMenuItemRefDirective)
    contextMenuItems: QueryList<MultiTabContextMenuItemRefDirective>;

    @HostListener('document:keydown.escape', ['$event'])
    onKeydownHandler(event: KeyboardEvent) {
        this.closed.emit();
    }

    constructor() { }

    ngAfterContentInit() {
        this.contextMenuItems.map((item) => {
            if (item.clicked) {
                this.closed.emit();
            }
        });
    }
}
